import Icon, * as Icons from '@ant-design/icons';
import { Breadcrumb, Button, Flex } from 'antd';
import { Link } from 'react-router-dom';
import { useBack } from '@refinedev/core';

interface CustomBreadcrumbProps {
  label: string;
  icon?: React.ComponentType<{ className?: string }>;
  backButton?: boolean;
  items: {
    label: string;
    path?: string;
    icon?: React.ComponentType<{ className?: string }>;
  }[];
}

export const CustomBreadcrumb = ({
  label,
  icon,
  items,
  backButton = false
}: CustomBreadcrumbProps) => {
  const back = useBack();
  return (
    <Breadcrumb>
      <Breadcrumb.Item>
        <Flex align="center" gap={4}>
          {icon ? <Icon component={icon} /> : null}

          {backButton ? (
            <Button
              icon={<Icons.ArrowLeftOutlined />}
              onClick={back}
              type="text"
              size="small"
              className="!p-0 text-gray-500"
            />
          ) : null}

          {label}
        </Flex>
      </Breadcrumb.Item>

      {items.map((item, index) => (
        <Breadcrumb.Item key={`${item.label}-${index}`}>
          <Flex align="center" gap={4}>
            {item.path ? (
              <Link to={item.path}>
                {item.icon ? <Icon component={item.icon} /> : null}
                {item.label}
              </Link>
            ) : (
              <>
                {item.icon ? <Icon component={item.icon} /> : null}
                {item.label}
              </>
            )}
          </Flex>
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  );
};
